import { Dispatch } from 'react';
import { PaginateList } from 'src/app/common/types/common-types';
import { SharingActivityParams, SharingActivityItem } from '../types/mdrt-hub-types';
import { apiClient, apiErrorHandler } from 'src/app/common/network';

const ADMIN_URL = `${window.envConfig['REACT_APP_APIM_BASE_URL']}${window.envConfig['REACT_APP_APIM_MDRT']}/mdrt-hub`;
// const ADMIN_URL = `http://localhost:3303`;

export const fetchSharingActivityList = async (
  params: SharingActivityParams,
  dispatch?: Dispatch<any>,
): Promise<PaginateList<SharingActivityItem>> => {
  const url = `${ADMIN_URL}/sharing-activity/report`;

  return apiClient
    .post(url, params)
    .then((response: any) => response.data)
    .catch((err: any) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const fetchSharingActivityDownload = async (params: SharingActivityParams, dispatch?: Dispatch<any>) => {
  const url = `${ADMIN_URL}/sharing-activity/report/export`;

  apiClient
    .post(url, params)
    .then((response: any) => {
      const url = window.URL.createObjectURL(
        new Blob(['\uFEFF' + response.data], {
          type: 'text/csv;charset=utf-8;',
        }),
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'mdrt-sharing-activity-tracking' + new Date().toISOString() + '.csv');
      document.body.appendChild(link);
      link.click();
    })
    .catch((err: any) => {
      throw apiErrorHandler(err, dispatch);
    });
};
